import React from 'react';
import { Sidebar } from './components/layout/Sidebar';
import { Header } from './components/layout/Header';
import { WorkspaceHub } from './components/workspace/WorkspaceHub';
export function App() {
  return <div className="flex h-screen w-full bg-gray-50" data-id="element-0">
      <Sidebar data-id="element-1" />
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-2">
        <Header data-id="element-3" />
        <main className="flex-1 overflow-y-auto p-6" data-id="element-4">
          <WorkspaceHub data-id="element-5" />
        </main>
      </div>
    </div>;
}